import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility: compose Tailwind class strings safely.
 * Merges conflicting utility classes via tailwind-merge.
 * Usage: cn('px-4 py-2', isActive && 'bg-du-blue text-white')
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
